import React, { useContext } from "react";
import { GlobalContext } from "../context/GlobalState";
import Container from "@material-ui/core/Container";

import SuperStar from "./SuperStar";

const SuperStars = () => {
  const superStarsContext = useContext(GlobalContext);

  const { superstars } = superStarsContext;

  return (
    <div className="cards-container">
      <Container>
        {superstars.map((superstar) => (
          <SuperStar key={superstar.id} superstar={superstar} />
        ))}
      </Container>
    </div>
  );
};

export default SuperStars;
